import React from "react";
import { Form, Button, Card } from "react-bootstrap";
import { FaCreditCard, FaUniversity, FaGlobe, FaShieldAlt, FaArrowLeft } from "react-icons/fa";
import { useParams, useNavigate } from "react-router-dom";

const PaymentProcessing = () => {
      const navigate = useNavigate();
    
  return (
    <div className="container py-4">
      {/* Header */}
      <div className="mb-4">
        <h5 ><FaArrowLeft className="me-2 cursor-pointer" size={20}  onClick={() => navigate(-1)}/>Payment Processing</h5>
        <small className="text-muted">RFQ-2025-0001 - Office Solutions Pro</small>
      </div>

      {/* Layout */}
      <div className="row g-4">
        {/* Left: Payment Method */}
        <div className="col-md-7">
          <Card className="shadow-sm p-3">
            <h6 className=" mb-3">Payment Method</h6>

            {/* Credit / Debit */}
            <div className="border rounded p-2 mb-3 d-flex justify-content-between align-items-center">
              <span><FaCreditCard className="me-2" /> Credit / Debit card</span>
              <input type="radio" name="paymentMethod" defaultChecked />
            </div>

            {/* Card Information */}
            <Card className="bg-light p-3 mb-3 border-0">
              <Form.Group className="mb-3">
                <Form.Label>Card Number</Form.Label>
                <Form.Control type="text" placeholder="1234 5678 8521 1087" />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Card Holder Name</Form.Label>
                <Form.Control type="text" placeholder="Jasmin Singh" />
              </Form.Group>

              <div className="d-flex gap-3">
                <Form.Group className="flex-grow-1">
                  <Form.Label>Expiry Date</Form.Label>
                  <Form.Control type="text" placeholder="MM/YYYY" />
                </Form.Group>
                <Form.Group className="flex-grow-1">
                  <Form.Label>CVV</Form.Label>
                  <Form.Control type="text" placeholder="123" />
                </Form.Group>
              </div>
            </Card>

            {/* Bank Transfer */}
            <div className="border rounded p-2 mb-2 d-flex justify-content-between align-items-center">
              <span><FaUniversity className="me-2" /> Bank Transfer</span>
              <input type="radio" name="paymentMethod" />
            </div>

            {/* Online */}
            <div className="border rounded p-2 d-flex justify-content-between align-items-center">
              <span><FaGlobe className="me-2" /> Online</span>
              <input type="radio" name="paymentMethod" />
            </div>
          </Card>
        </div>

        {/* Right: Order Summary */}
        <div className="col-md-5">
          <Card className="shadow-sm p-3 mb-3">
            <h6 className=" mb-3">Order Summary</h6>
            <div className="d-flex justify-content-between mb-2">
              <span>Supplier</span> <span>Office Solutions Pro</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span>Subtotal</span> <span>AED 8,750</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span>Tax</span> <span>AED 120</span>
            </div>
            <div className="d-flex justify-content-between  border-top pt-2">
              <span>Total</span> <span>AED 8,870</span>
            </div>
          </Card>

          {/* Secure Payment */}
          <Card className="shadow-sm border-success mb-3 p-3 bg-light">
            <div className="d-flex">
              <FaShieldAlt className="text-success me-2 mt-1" />
              <div>
                <h6 className="text-success ">Secure Payment</h6>
                <p className="small mb-0 " style={{color:"green"}}>
                  Your payment information is encrypted and secure. We use
                  industry-standard security measures to protect your data.
                </p>
              </div>
            </div>
          </Card>

          <button style={{background:"#d01c4c",color:"white",border: "1px solid #d92557", padding: "8px 16px"}} className="btn-btn w-100">
            Process Payment
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentProcessing;
